<ag-grid-angular #agGrid
	class="ag-theme-alpine"
	[gridOptions]="this.gridOptions"
	[rowData]="this.rowData"
	[columnDefs]="this.columnDefs"
	style="width:616px; height: 384px; border: none;">
	</ag-grid-angular>

